import { unitOfTime } from 'moment'
import * as moment from 'moment-timezone'

import { MembershipDefinition, Organization, MembershipEffectiveType, DEFAULT_TIMEZONE } from 'app/models'

export class MembershipEffectivityService {

  private _effectiveAt: Date
  private _expiresAt: Date

  constructor(
    public memdef: MembershipDefinition,
    public org: Organization,
    public startDate?: string
  ) {
    this.parseDates()
  }

  public get effectiveAt(): Date { return this._effectiveAt }
  public get expiresAt(): Date { return this._expiresAt }

  private parseDates(): void {
    if (this.memdef.effective_type === MembershipEffectiveType.Termed) {
      this._effectiveAt = this.memdef.start_date
      this._expiresAt = this.memdef.end_date
      return
    }
    if (this.memdef.effective_type === MembershipEffectiveType.PickADate) {
      const timezone = (this.org.timezone) ? this.org.timezone : DEFAULT_TIMEZONE
      const duration_type: unitOfTime.DurationConstructor = this.memdef.duration_type as unitOfTime.DurationConstructor
      this._effectiveAt = moment(this.startDate).tz(timezone).toDate()
      this._expiresAt = moment(this.startDate)
        .add(this.memdef.duration_value, duration_type)
        .subtract(1, 'day')
        .tz(timezone).toDate()
    }
  }
}
